import store from "../../reduxStore/store";
import { getLoggedInRepDetailsFromSession } from "../../services/apiServices/salesRepDataService";
import { logClientRuntimeError } from "../../services/clientErrorLog";
import { createDefaultSalesOrderDetailsColumnVisibility, SALES_ORDER_DETAILS_COLUMN_KEYS, } from "./salesOrderDetailsColumns";
import { createDefaultSalesOrderDetailsRefundColumnVisibility, SALES_ORDER_DETAILS_REFUND_COLUMN_KEYS, } from "./salesOrderDetailsRefundColumns";
var ORDER_COLUMNS_KEY_PREFIX = "salesRepOrderDetailsColumns_";
var REFUND_COLUMNS_KEY_PREFIX = "salesRepOrderDetailsRefundColumns_";
/** Logged-in rep / customer id for per-user localStorage (shared browser safe). */
export function resolveSalesRepOrderDetailsUserId() {
    var _a, _b, _c;
    try {
        var fromSession = (_a = getLoggedInRepDetailsFromSession()) === null || _a === void 0 ? void 0 : _a.CustomerId;
        if (fromSession != null && String(fromSession).trim() !== "") {
            return String(fromSession).trim();
        }
    }
    catch (error) {
        logClientRuntimeError("salesOrderDetailsColumnStorage.resolveSalesRepOrderDetailsUserId.session", error);
    }
    try {
        var fromRedux = (_c = (_b = store.getState().salesRepData) === null || _b === void 0 ? void 0 : _b.loggedInRepDetails) === null || _c === void 0 ? void 0 : _c.customerId;
        if (fromRedux != null && String(fromRedux).trim() !== "") {
            return String(fromRedux).trim();
        }
    }
    catch (error) {
        logClientRuntimeError("salesOrderDetailsColumnStorage.resolveSalesRepOrderDetailsUserId.redux", error);
    }
    return null;
}
function buildOrderColumnsStorageKey(userId) {
    try {
        return "".concat(ORDER_COLUMNS_KEY_PREFIX).concat(userId);
    }
    catch (error) {
        logClientRuntimeError("salesOrderDetailsColumnStorage.buildOrderColumnsStorageKey", error);
        return null;
    }
}
function buildRefundColumnsStorageKey(userId) {
    try {
        return "".concat(REFUND_COLUMNS_KEY_PREFIX).concat(userId);
    }
    catch (error) {
        logClientRuntimeError("salesOrderDetailsColumnStorage.buildRefundColumnsStorageKey", error);
        return null;
    }
}
function parseVisibilityJson(raw) {
    if (!raw) {
        return null;
    }
    try {
        var parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
            return null;
        }
        var out = {};
        for (var _i = 0, _a = Object.entries(parsed); _i < _a.length; _i++) {
            var _b = _a[_i], key = _b[0], value = _b[1];
            if (typeof value === "boolean") {
                out[key] = value;
            }
        }
        return Object.keys(out).length > 0 ? out : null;
    }
    catch (error) {
        logClientRuntimeError("salesOrderDetailsColumnStorage.parseVisibilityJson", error);
        return null;
    }
}
function mergeOrderVisibility(saved, isB2BShop) {
    try {
        var merged = createDefaultSalesOrderDetailsColumnVisibility(isB2BShop);
        if (!saved) {
            return merged;
        }
        for (var _i = 0, SALES_ORDER_DETAILS_COLUMN_KEYS_1 = SALES_ORDER_DETAILS_COLUMN_KEYS; _i < SALES_ORDER_DETAILS_COLUMN_KEYS_1.length; _i++) {
            var key = SALES_ORDER_DETAILS_COLUMN_KEYS_1[_i];
            if (key === "companyName" || key === "companyLocation") {
                if (!isB2BShop) {
                    continue;
                }
            }
            if (typeof saved[key] === "boolean") {
                merged[key] = saved[key];
            }
        }
        return merged;
    }
    catch (error) {
        logClientRuntimeError("salesOrderDetailsColumnStorage.mergeOrderVisibility", error);
        return createDefaultSalesOrderDetailsColumnVisibility(isB2BShop);
    }
}
function mergeRefundVisibility(saved) {
    try {
        var merged = createDefaultSalesOrderDetailsRefundColumnVisibility();
        if (!saved) {
            return merged;
        }
        for (var _i = 0, SALES_ORDER_DETAILS_REFUND_COLUMN_KEYS_1 = SALES_ORDER_DETAILS_REFUND_COLUMN_KEYS; _i < SALES_ORDER_DETAILS_REFUND_COLUMN_KEYS_1.length; _i++) {
            var key = SALES_ORDER_DETAILS_REFUND_COLUMN_KEYS_1[_i];
            if (typeof saved[key] === "boolean") {
                merged[key] = saved[key];
            }
        }
        return merged;
    }
    catch (error) {
        logClientRuntimeError("salesOrderDetailsColumnStorage.mergeRefundVisibility", error);
        return createDefaultSalesOrderDetailsRefundColumnVisibility();
    }
}
export function loadSalesRepOrderDetailsColumnVisibility(isB2BShop) {
    try {
        var userId = resolveSalesRepOrderDetailsUserId();
        if (!userId) {
            return createDefaultSalesOrderDetailsColumnVisibility(isB2BShop);
        }
        var key = buildOrderColumnsStorageKey(userId);
        if (!key) {
            return createDefaultSalesOrderDetailsColumnVisibility(isB2BShop);
        }
        var saved = parseVisibilityJson(localStorage.getItem(key));
        return mergeOrderVisibility(saved, isB2BShop);
    }
    catch (error) {
        logClientRuntimeError("salesOrderDetailsColumnStorage.loadSalesRepOrderDetailsColumnVisibility", error);
        return createDefaultSalesOrderDetailsColumnVisibility(isB2BShop);
    }
}
export function loadSalesRepOrderDetailsRefundColumnVisibility() {
    try {
        var userId = resolveSalesRepOrderDetailsUserId();
        if (!userId) {
            return createDefaultSalesOrderDetailsRefundColumnVisibility();
        }
        var key = buildRefundColumnsStorageKey(userId);
        if (!key) {
            return createDefaultSalesOrderDetailsRefundColumnVisibility();
        }
        var saved = parseVisibilityJson(localStorage.getItem(key));
        return mergeRefundVisibility(saved);
    }
    catch (error) {
        logClientRuntimeError("salesOrderDetailsColumnStorage.loadSalesRepOrderDetailsRefundColumnVisibility", error);
        return createDefaultSalesOrderDetailsRefundColumnVisibility();
    }
}
export function saveSalesRepOrderDetailsColumnVisibility(userId, visibility) {
    try {
        var payload = {};
        for (var _i = 0, SALES_ORDER_DETAILS_COLUMN_KEYS_2 = SALES_ORDER_DETAILS_COLUMN_KEYS; _i < SALES_ORDER_DETAILS_COLUMN_KEYS_2.length; _i++) {
            var key_1 = SALES_ORDER_DETAILS_COLUMN_KEYS_2[_i];
            if (typeof visibility[key_1] === "boolean") {
                payload[key_1] = visibility[key_1];
            }
        }
        var key = buildOrderColumnsStorageKey(userId);
        if (!key) {
            return;
        }
        localStorage.setItem(key, JSON.stringify(payload));
    }
    catch (error) {
        logClientRuntimeError("salesOrderDetailsColumnStorage.saveSalesRepOrderDetailsColumnVisibility", error);
    }
}
export function saveSalesRepOrderDetailsRefundColumnVisibility(userId, visibility) {
    try {
        var payload = {};
        for (var _i = 0, SALES_ORDER_DETAILS_REFUND_COLUMN_KEYS_2 = SALES_ORDER_DETAILS_REFUND_COLUMN_KEYS; _i < SALES_ORDER_DETAILS_REFUND_COLUMN_KEYS_2.length; _i++) {
            var key_2 = SALES_ORDER_DETAILS_REFUND_COLUMN_KEYS_2[_i];
            if (typeof visibility[key_2] === "boolean") {
                payload[key_2] = visibility[key_2];
            }
        }
        var key = buildRefundColumnsStorageKey(userId);
        if (!key) {
            return;
        }
        localStorage.setItem(key, JSON.stringify(payload));
    }
    catch (error) {
        logClientRuntimeError("salesOrderDetailsColumnStorage.saveSalesRepOrderDetailsRefundColumnVisibility", error);
    }
}
export function persistSalesRepOrderDetailsColumnVisibility(visibility) {
    try {
        var userId = resolveSalesRepOrderDetailsUserId();
        if (!userId) {
            return;
        }
        saveSalesRepOrderDetailsColumnVisibility(userId, visibility);
    }
    catch (error) {
        logClientRuntimeError("salesOrderDetailsColumnStorage.persistSalesRepOrderDetailsColumnVisibility", error);
    }
}
export function persistSalesRepOrderDetailsRefundColumnVisibility(visibility) {
    try {
        var userId = resolveSalesRepOrderDetailsUserId();
        if (!userId) {
            return;
        }
        saveSalesRepOrderDetailsRefundColumnVisibility(userId, visibility);
    }
    catch (error) {
        logClientRuntimeError("salesOrderDetailsColumnStorage.persistSalesRepOrderDetailsRefundColumnVisibility", error);
    }
}
